import React, { useCallback, useEffect, useState } from "react";
import useReactRouter from "use-react-router";
import * as _ from "lodash";
import { Tabs, Tab, Button, Card, Spinner } from "react-bootstrap";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faVideoCamera,
    faChevronRight,
    faTrash
} from "@fortawesome/free-solid-svg-icons";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_ORDERS, GET_ORDERS_V2 } from "../../../graphql/order/query";
import { useToasts } from "react-toast-notifications";
import { UPDATE_STOCK } from "../../../graphql/stock/mutation";
import BasicModal from "../../../components/BasicModal";
import { COLOR_APP, CREATED } from "../../../constants";
import LiveDetailCF from "./LiveDetailCF";
import { GET_LIVE_STOCKS } from "../../../graphql/liveStock/query";
import { DELETE_LIVE } from "../../../graphql/live/mutation";
import LiveDetailSummary from "./LiveDetailSummary";
import LiveDetailLiveStock from "./LiveDetailLiveStock";
import useWindowDimensions from "../../../helpers/useWindowDimensions";
import { moneyCurrency } from "../../../helpers";
import PostDetailMessage from "../../PostFeed/postDetail/PostDetailMessage";
import { FaSitemap, FaUserFriends } from "react-icons/fa";
import { MdAttachMoney, MdOutlineInsertComment } from "react-icons/md";
import { GrMoney } from "react-icons/gr";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { GiMoneyStack } from "react-icons/gi";
import { GET_POST_COMMENTS_V2 } from "../../../graphql/postComment/query";
import { BsPeople } from "react-icons/bs";
import { IoBagAddOutline } from "react-icons/io5";


function LiveDetail() {
    const { history } = useReactRouter();

    const [liveData, setLiveData] = useState();
    const [totalCmOrderAll, setotalCmOrderAll] = useState(0);
    const [totalPersonCm, setTotalPersonCm] = useState(0);
    const [key, setKey] = useState("order");
    const [liveStocksTotalNew, setPostStocksTotalNew] = useState(0);
    const [allPrice, setAllPrice] = useState(0);
    const [allPriceBaht, setAllPriceBaht] = useState(0);
    const [allPriceUsd, setAllPriceUsd] = useState(0);
    const [peopleOrders, setPeopleOrders] = useState([]);
    const [totalOrder, setTotalOrder] = useState(0);
    const [total, setTotal] = useState(0);
    const [postDetailSummary, setPostDetailSummary] = useState([]);
    const [showDeletePostConfirm, setShowDeletePostConfirm] = useState(false);
    const [liveStocksNew, setLiveStocksNew] = useState([])
    const [liveSreenType, setLiveSreenType] = useState();
    const [totalCommentsAll, setTotalCommentsAll] = useState(0)
    const [totalPsCm, setTotalPsCm] = useState(0)
    

    const [getOrderData, { data: orderData, loading: loadingOrderData }] = useLazyQuery(GET_ORDERS_V2, { fetchPolicy: "cache-and-network" });
    const [getLiveCommentsV2, { data: liveCommentsData, loading: liveCommentsLoading }] = useLazyQuery(GET_POST_COMMENTS_V2, { fetchPolicy: "cache-and-network" });
    // pagination function 
    const rowsPerPage = 50;
    const [page, setPage] = useState(0);
    const pageAll = totalOrder > 0 ? Math.ceil(totalOrder / rowsPerPage) : 1;
    const handleChangePage = useCallback((newPage) => {
        setPage(newPage);
    }, []);

    // useEffect Hooks
    useEffect(() => {
        if (history.location.state.live) {
            setLiveData(history.location.state.live);
        } else {
            history.goBack();
        }
    }, []);

    useEffect(() => {
        if (liveData?.id) {
            fetchDatas(liveData?.id);
        }
    }, [liveData, page])
    


    useEffect(() => {

        // set all people order
        let _newpeopleOrders = _.groupBy(orderData?.ordersV2?.data, "cfName");
        setPeopleOrders(Object.values(_newpeopleOrders));

        setAllPrice(orderData?.ordersV2?.reportHistory?.priceLak);
        setAllPriceBaht(orderData?.ordersV2?.reportHistory?.priceThb);
        setAllPriceUsd(orderData?.ordersV2?.reportHistory?.priceUsd);
        setTotalOrder(orderData?.ordersV2?.reportHistory?.totalOrder)
        setTotal(orderData?.ordersV2?.total)
        setTotalCommentsAll(orderData?.ordersV2?.totalCommentsAll)
        setTotalPsCm(orderData?.ordersV2?.totalPsCm)
        


        // set post detail summary
        let _newPostSummaryDetail = Object.values(_.groupBy(orderData?.ordersV2?.data, 'cfMessage'));
        setPostDetailSummary(_newPostSummaryDetail);

    }, [orderData]);

     // useEffect Hooks
        useEffect(() => {
            handleFetchComment()
        }, [page, liveData])
    
        useEffect(() => {
            if (liveCommentsData?.postCommentsV2) {
                setotalCmOrderAll(liveCommentsData?.postCommentsV2?.data.total)
                setTotalPersonCm(liveCommentsData?.postCommentsV2?.data?.totalPsCm)
            }
        }, [liveCommentsData])
    
    
        // fetch comments alls
        const handleFetchComment = async () => {
            await getLiveCommentsV2({
                variables: {
                    where: {
                        post: liveData?.id
                    },
                    limit: rowsPerPage,
                    skip: page * rowsPerPage,
                    orderBy: "createdAt_DESC"
                }
            })
        }
    

    const fetchDatas = async (_liveId) => {
        if (loadingOrderData) return;

        try {
            await getOrderData({
                variables: {
                    where: {
                        live: _liveId,
                        isDeleted: false,
                        status: CREATED
                    },
                    limit: rowsPerPage,
                    skip: page * rowsPerPage,
                }
            })
        } catch (error) {
            console.error({ error })
        }
    }

    const triggerHideDeletePostConfirm = () => setShowDeletePostConfirm(false);
    const triggerShowDeletePostConfirm = () => setShowDeletePostConfirm(true);

    const { height, width } = useWindowDimensions();

    const handleChangeEventkey = (eventKey) => {
        setKey(eventKey)
        if (eventKey === "postComment") {
            setLiveSreenType("LIVE")
        }
    }
    return (
        <div>
            <BasicModal show={showDeletePostConfirm} Illustration={'images/Illustration.png'} onHide={triggerHideDeletePostConfirm} title="ທ່ານຕ້ອງການລຶບຂໍ້ມູນ ຫຼື ບໍ່" leftButtonName="ຍົກເລີກ" rightButtonName="ຕົກລົງ" />
            <div
                style={{
                    display: "flex",
                    justifyItems: "center",
                    background: "#F6F6F6",
                    padding: 20,
                }}
            >
                {/* <Link to={"/"}> */}
                <button
                    style={{
                        fontSize: "16px",
                        color: "#371895",
                        margin: "0 10px",
                        border: "none",
                    }}
                    onClick={() => history.replace("/live-manage/history/limit/30/page/1")}
                >
                    <FontAwesomeIcon
                        icon={faVideoCamera}
                        style={{ marginRight: "5px" }}
                    />
                    ຈັດການ Live
                </button>
                {/* </Link> */}
                <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{
                        padding: "0px 2px",
                        color: "#252A31",
                        fontSize: "11px",
                        paddingTop: "8px",
                    }}
                />

                <button
                    style={{
                        margin: "0 10px",
                        fontSize: "16px",
                        color: "#252A31",
                        cursor: "default",
                        border: "none",
                    }}
                >
                    {'> '}ລາຍລະອຽດການໄລຟ
                </button>
            </div>
            <div
                style={{
                    borderRadius: "12px",
                    background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                    padding: "16px",
                    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
                    marginBottom: "16px"
                }}
            >
                {/* Live Information Section */}
                <div
                    style={{
                        display: "flex",
                        flexDirection: width > 768 ? 'row' : 'column',
                        gap: "16px",
                        marginBottom: "16px"
                    }}
                >
                    {/* Live Details Card */}
                    <div style={{ 
                        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)', 
                        padding: "16px", 
                        borderRadius: "8px",
                        flex: 1,
                        boxShadow: "0 1px 8px rgba(0, 0, 0, 0.04)",
                        border: "1px solid rgba(90, 84, 162, 0.1)"
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                            <div style={{ flex: 1 }}>
                                <h3 style={{ 
                                    color: "#5a54a2", 
                                    fontSize: width > 768 ? "18px" : "16px",
                                    fontWeight: "600",
                                    marginBottom: "12px",
                                    lineHeight: "1.3"
                                }}>
                                    ຫົວຂໍ້ໄລຟ: {liveData?.description === null ? "ບໍ່ມີຫົວຂໍ້" : liveData?.description}
                                </h3>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                    <p style={{ 
                                        color: "#6c757d", 
                                        fontSize: "13px",
                                        margin: 0,
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        <strong style={{ color: "#5a54a2", marginRight: "6px" }}>ຊື່ເພຈ:</strong> 
                                        {liveData?.pageName}
                                    </p>
                                    <p style={{ 
                                        color: "#6c757d", 
                                        fontSize: "13px",
                                        margin: 0,
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        <strong style={{ color: "#5a54a2", marginRight: "6px" }}>ວັນທີສ້າງໄລຟ:</strong> 
                                        {moment(liveData?.createdAt).format("DD/MM/YYYY HH:mm")}
                                    </p>
                                </div>
                                <div style={{ 
                                    marginTop: "12px",
                                    padding: "8px",
                                    background: "rgba(219, 18, 55, 0.1)",
                                    borderRadius: "6px",
                                    borderLeft: "3px solid #DB1237"
                                }}>
                                    <p style={{ 
                                        color: '#DB1237', 
                                        fontSize: "12px",
                                        margin: 0,
                                        fontWeight: "500"
                                    }}>
                                        #ຫມາຍເຫດ: ສຳລັບຄອມເມັ້ນ ສາມາດເບີ່ງໄດ້ສະເພາະພາຍໃນນື່ງເດືອນເທົ່ານັ້ນ
                                    </p>
                                </div>
                            </div>
                            {liveData?.status === CREATED && (
                                <button
                                    onClick={triggerShowDeletePostConfirm}
                                    style={{
                                        color: "#fff",
                                        background: "linear-gradient(135deg, #dc3545 0%, #c82333 100%)",
                                        border: "none",
                                        borderRadius: "6px",
                                        padding: "6px 12px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        fontSize: "13px",
                                        fontWeight: "500",
                                        cursor: "pointer",
                                        transition: "all 0.3s ease",
                                        boxShadow: "0 1px 6px rgba(220, 53, 69, 0.3)",
                                        marginLeft: "12px"
                                    }}
                                    onMouseOver={(e) => {
                                        e.target.style.transform = "translateY(-1px)";
                                        e.target.style.boxShadow = "0 2px 8px rgba(220, 53, 69, 0.4)";
                                    }}
                                    onMouseOut={(e) => {
                                        e.target.style.transform = "translateY(0)";
                                        e.target.style.boxShadow = "0 1px 6px rgba(220, 53, 69, 0.3)";
                                    }}
                                >
                                    <FontAwesomeIcon icon={faTrash} />
                                    ລຶບໄລຟ
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Quick Stats Cards */}
                    <div
                        style={{
                            display: "flex",
                            flexDirection: width > 768 ? 'column' : 'row',
                            gap: "8px",
                            flex: width > 768 ? '0 0 240px' : '1'
                        }}
                    >
                        <Card style={{ 
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)', 
                            border: 'none',
                            borderRadius: '8px',
                            background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                            flex: 1
                        }}>
                            <Card.Header style={{
                                background: 'linear-gradient(135deg, #5a54a2 0%, #4a4490 100%)',
                                color: 'white',
                                fontSize: '12px',
                                fontWeight: '500',
                                borderRadius: '8px 8px 0 0',
                                padding: '8px 12px'
                            }}>
                                ຈຳນວນສິນຄ້າທີ່ເພີ່ມເຂົ້າ {loadingOrderData && <Spinner size="sm" />}
                            </Card.Header>
                            <Card.Body style={{ padding: '12px', textAlign: 'center' }}>
                                <div style={{ marginBottom: '6px' }}>
                                    <IoBagAddOutline style={{ fontSize: 20, color: '#5a54a2', opacity: 0.8 }} />
                                </div>
                                <Card.Text as="h3" style={{ 
                                    color: '#5a54a2', 
                                    fontWeight: '700',
                                    fontSize: '18px',
                                    margin: 0
                                }}>
                                    {Intl.NumberFormat("en-US").format(liveStocksTotalNew ?? 0)}
                                </Card.Text>
                            </Card.Body>
                        </Card>

                        <Card style={{ 
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)', 
                            border: 'none',
                            borderRadius: '8px',
                            background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                            flex: 1
                        }}>
                            <Card.Header style={{
                                background: 'linear-gradient(135deg, #28a745 0%, #20a039 100%)',
                                color: 'white',
                                fontSize: '12px',
                                fontWeight: '500',
                                borderRadius: '8px 8px 0 0',
                                padding: '8px 12px'
                            }}>
                                ຍອດລາຍຮັບ {loadingOrderData && <Spinner size="sm" />}
                            </Card.Header>
                            <Card.Body style={{ padding: '12px', textAlign: 'center' }}>
                                <div style={{ marginBottom: '6px' }}>
                                    <GiMoneyStack style={{ fontSize: 20, color: '#28a745', opacity: 0.8 }} />
                                </div>
                                <Card.Text as="div">
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                        {allPrice > 0 && <h4 style={{ color: '#28a745', fontWeight: '600', fontSize: '14px', margin: 0 }}>{moneyCurrency(allPrice) + " ກີບ"}</h4>}
                                        {allPriceBaht > 0 && <h4 style={{ color: '#28a745', fontWeight: '600', fontSize: '14px', margin: 0 }}>{moneyCurrency(allPriceBaht) + " ບາດ"}</h4>}
                                        {allPriceUsd > 0 && <h4 style={{ color: '#28a745', fontWeight: '600', fontSize: '14px', margin: 0 }}>{moneyCurrency(allPriceUsd) + " ໂດລາ"}</h4>}
                                    </div>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </div>
                </div>

                {/* Statistics Grid */}
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: width > 1200 ? 'repeat(4, 1fr)' : width > 768 ? 'repeat(2, 1fr)' : '1fr',
                        gap: "12px"
                    }}
                >
                    <Card style={{ 
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)', 
                        border: 'none',
                        borderRadius: '8px',
                        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                        transition: 'all 0.3s ease'
                    }}>
                        <Card.Header style={{
                            background: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)',
                            color: 'white',
                            fontSize: '12px',
                            fontWeight: '500',
                            borderRadius: '8px 8px 0 0',
                            padding: '8px 12px'
                        }}>
                            ຈຳນວນຄົນທີ່ຄອມເມັ້ນລະຫັດສີ້ນຄ້າ {loadingOrderData && <Spinner size="sm" />}
                        </Card.Header>
                        <Card.Body style={{ padding: '12px', textAlign: 'center' }}>
                            <div style={{ marginBottom: '6px' }}>
                                <BsPeople style={{ fontSize: 20, color: '#17a2b8', opacity: 0.8 }} />
                            </div>
                            <Card.Text as="h3" style={{ 
                                color: '#17a2b8', 
                                fontWeight: '700',
                                fontSize: '18px',
                                margin: 0
                            }}>
                                {Intl.NumberFormat("en-US").format(totalPsCm ?? 0)}
                            </Card.Text>
                        </Card.Body>
                    </Card>

                    <Card style={{ 
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)', 
                        border: 'none',
                        borderRadius: '8px',
                        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                        transition: 'all 0.3s ease'
                    }}>
                        <Card.Header style={{
                            background: 'linear-gradient(135deg, #fd7e14 0%, #e8650e 100%)',
                            color: 'white',
                            fontSize: '12px',
                            fontWeight: '500',
                            borderRadius: '8px 8px 0 0',
                            padding: '8px 12px'
                        }}>
                            ຈຳນວນອໍເດີ້ທັງຫມົດ {loadingOrderData && <Spinner size="sm" />}
                        </Card.Header>
                        <Card.Body style={{ padding: '12px', textAlign: 'center' }}>
                            <div style={{ marginBottom: '6px' }}>
                                <FaSitemap style={{ fontSize: 20, color: '#fd7e14', opacity: 0.8 }} />
                            </div>
                            <Card.Text as="h3" style={{ 
                                color: '#fd7e14', 
                                fontWeight: '700',
                                fontSize: '18px',
                                margin: 0
                            }}>
                                {totalOrder ?? 0}
                            </Card.Text>
                        </Card.Body>
                    </Card>

                    <Card style={{ 
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)', 
                        border: 'none',
                        borderRadius: '8px',
                        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                        transition: 'all 0.3s ease'
                    }}>
                        <Card.Header style={{
                            background: 'linear-gradient(135deg, #6f42c1 0%, #5a32a3 100%)',
                            color: 'white',
                            fontSize: '12px',
                            fontWeight: '500',
                            borderRadius: '8px 8px 0 0',
                            padding: '8px 12px'
                        }}>
                            ຈຳນວນຄົນຄອມເມັ້ນ {liveCommentsLoading && <Spinner size="sm" />}
                        </Card.Header>
                        <Card.Body style={{ padding: '12px', textAlign: 'center' }}>
                            <div style={{ marginBottom: '6px' }}>
                                <BsPeople style={{ fontSize: 20, color: '#6f42c1', opacity: 0.8 }} />
                            </div>
                            <Card.Text as="h3" style={{ 
                                color: '#6f42c1', 
                                fontWeight: '700',
                                fontSize: '18px',
                                margin: 0
                            }}>
                                {Intl.NumberFormat("en-US").format(totalPersonCm ?? 0)}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    
                    <Card style={{ 
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)', 
                        border: 'none',
                        borderRadius: '8px',
                        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                        transition: 'all 0.3s ease'
                    }}>
                        <Card.Header style={{
                            background: 'linear-gradient(135deg, #DB1237 0%, #c10e2f 100%)',
                            color: 'white',
                            fontSize: '12px',
                            fontWeight: '500',
                            borderRadius: '8px 8px 0 0',
                            padding: '8px 12px'
                        }}>
                            ຈຳນວນຄອມເມັ້ນທັງໝົດ {liveCommentsLoading && <Spinner size="sm" />}
                        </Card.Header>
                        <Card.Body style={{ padding: '12px', textAlign: 'center' }}>
                            <div style={{ marginBottom: '6px' }}>
                                <MdOutlineInsertComment style={{ fontSize: 20, color: '#DB1237', opacity: 0.8 }} />
                            </div>
                            <Card.Text as="h3" style={{ 
                                color: '#DB1237', 
                                fontWeight: '700',
                                fontSize: '18px',
                                margin: 0
                            }}>
                                {Intl.NumberFormat("en-US").format(totalCommentsAll ?? 0)}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </div>
            </div>
            <div style={{ height: 15 }} />
            <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(e) => handleChangeEventkey(e)}
            >
                <Tab eventKey="order" title="ຄົນສັ່ງຊື້">
                    {(orderData && loadingOrderData) ? (
                        <LoadingSpinner />
                    ) : (
                        <LiveDetailCF peopleOrders={peopleOrders} liveData={liveData} totalOrder={totalOrder} page={page} pageAll={pageAll} rowsPerPage={rowsPerPage} handleChangePage={handleChangePage} />
                    )}
                </Tab>
                <Tab eventKey="home" title="ສະຫຼຸບຍອດ">
                    {(orderData && loadingOrderData) ? (
                        <LoadingSpinner />
                    ) : (
                        <LiveDetailSummary postDetailSummary={postDetailSummary} liveData={liveData} totalOrder={totalOrder} page={page} pageAll={pageAll} rowsPerPage={rowsPerPage} handleChangePage={handleChangePage} />
                    )}
                </Tab>
                <Tab eventKey="stock" title="ສິນຄ້າ">
                    <LiveDetailLiveStock liveData={liveData} setLiveStocksNew={setLiveStocksNew} setPostStocksTotalNew={setPostStocksTotalNew} />
                </Tab>
                <Tab eventKey="postComment" title="ຄອມເມັ້ນທັງໝົດ">
                    <PostDetailMessage liveData={liveData} postStocks={liveStocksNew} liveSreenType={liveSreenType} />
                </Tab>
            </Tabs>
        </div>
    );
}

export default LiveDetail;
